import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useLocalParticipant, useDaily, useDevices } from '@daily-co/daily-react';
import { pageAtom, isAuthAtom, cameraInputAtom } from '../../State';
import { getAuth, signOut } from 'firebase/auth';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import AddAccess from '../Util/AddAccess';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import KUTE from 'kute.js';

//アイコン系
import { ReactComponent as LogoutSVG } from '../Images/buttons/settingLogout.svg';

import { ReactComponent as MiniSVG } from '../Images/buttons/windowMinimizeButton.svg';
import { ReactComponent as ProfileSVG } from '../Images/buttons/settingProfileButton.svg';
import { ReactComponent as LanguageSVG } from '../Images/buttons/settingLanguageButton.svg';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeBlackButton.svg';
import { ReactComponent as FeedbackSVG } from '../Images/buttons/feedbackIcon.svg';
import { ReactComponent as ContactSVG } from '../Images/buttons/contactusIcon.svg';
import { ReactComponent as FAQSVG } from '../Images/buttons/faqIcon.svg';
import { ReactComponent as SettingSVG } from '../Images/header/settingBlack.svg';
import { ReactComponent as MyMeetingSVG } from '../Images/buttons/mymeetingButton.svg';

//MUI系コンポーネント
import { useTranslation } from 'react-i18next';

export default function BrowserMenu({ showMenu, setShowMenu, meetingIDState }) {
  const { t, i18n } = useTranslation();
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [showLanguageState, setShowLanguageState] = useState(false);
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const navigate = useNavigate(); //リダイレクト用
  const closeWindow = (e) => {
    setShowMenu(false);
  };

  const tapMyRoom = (e) => {
    setPageState('myMeetingRoom');
    closeWindow();
  };

  const tapSetting = (e) => {
    setPageState('setting');
    closeWindow();
  };

  useEffect(() => {
    if (showMenu) {
      let kute = KUTE.to(
        '#menuWrap',
        { left: '0' },
        {
          duration: 300,
          easing: 'easingCubicOut',
          onComplete: () => {},
        },
      );
      kute.start();
    }
  }, [showMenu]);

  return (
    <>
      {showMenu && (
        <>
          <div className="addAreaBack" onClick={closeWindow}></div>
          <div id="menuWrap" style={{ left: '-100px' }}>
            <div className="menuHeader">
              <div className="menuTitle">Menu</div>
              <div className="menuClose">
                <CloseSVG onClick={closeWindow} />
              </div>
            </div>
            <ul className="menuMainList">
              <li onClick={tapMyRoom} style={{ alignItems: 'baseline' }}>
                <MyMeetingSVG />
                <div>
                  {t('setting.My meeting room')}

                  <div className="url">faceless.ooo/{meetingIDState}</div>
                </div>
              </li>

              <li onClick={tapSetting}>
                <SettingSVG />
                <div>{t('setting.Setting')}</div>
              </li>

              <li
                onClick={() => {
                  const url = 'https://faceless.ooo/faq';
                  window.open(url, '_blank');
                }}>
                <FAQSVG />
                <div>FAQ</div>
              </li>

              {/* <li
                onClick={() => {
                  navigate('/feedback');
                }}>
                <FeedbackSVG />
                <div>{t('setting.Feedback')}</div>
              </li>

              <li
                onClick={() => {
                  const url = 'https://faceless.ooo/contact';
                  window.open(url, '_blank');
                }}>
                <ContactSVG />
                <div>{t('setting.Contact us')}</div>
              </li> */}
            </ul>

            <ul className="menuSubList">
              <li
                onClick={() => {
                  navigate('/feedback');
                }}>
                <div>{t('setting.Feedback')}</div>
              </li>

              <li
                onClick={() => {
                  const url = 'https://faceless.ooo/contact';
                  window.open(url, '_blank');
                }}>
                <div>{t('setting.Contact us')}</div>
              </li>

              <li
                onClick={() => {
                  const url = 'https://faceless.ooo/terms';
                  window.open(url, '_blank');
                }}>
                <div>{t('mypage.Terms')}</div>
              </li>

              <li
                onClick={() => {
                  const url = 'https://faceless.ooo/privacy';
                  window.open(url, '_blank');
                }}>
                <div>{t('mypage.Privacy Policy')}</div>
              </li>
            </ul>
          </div>
        </>
      )}
    </>
  );
}
